import { useRef, useEffect } from 'react';

function makeCancellable(promise) {
  let isCancelled = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise
      .then((val) => (isCancelled ? reject({ isCancelled }) : resolve(val)))
      .catch((error) => (isCancelled ? reject({ isCancelled }) : reject(error)));
  });

  return {
    promise: wrappedPromise,
    cancel() {
      isCancelled = true;
    },
  };
}

export default function useCancellablePromise() {
  const promises = useRef();

  useEffect(() => {
    promises.current = promises.current || [];
    return function cancel() {
      promises.current.forEach(p => p.cancel());
      promises.current = [];
    };
  }, []);


  function cancellablePromise(p) {
    const cPromise = makeCancellable(p);
    promises.current.push(cPromise);
    return cPromise.promise;
  }

  function cancellableCPromise(p) {
    const cPromise = makeCancellable(p);
    promises.current.push(cPromise);
    return cPromise;
  }
  
  return { cancellablePromise, cancellableCPromise };
}